import React from 'react'
import PlayerComponent from '../../../../midea_viewer/playerComponent';
import { Player, ControlBar } from 'video-react';

function MediaRenderer({
    clickedContent,
    contentProviderType,
    playerRef,
    handleUserLastSeen,
    setType,
    setBookmarks,
    handleBookmarkClick,
    handleTimeUpdate,
    helper,
    handleTimeUpdateVdoCiphyer
}) {
    if (["image", "png", "jpg", "jpeg", "PNG", "JPG"].includes(clickedContent?.fileInfo?.fileType)) {
        return (
            <div className="pdf-canvas-container">
                <img src={clickedContent?.fileInfo?.fileURL} alt={clickedContent?.fileInfo?.fileName} />
            </div>
        );
    } else if (["VdoCipher", "S3", "Google Cloud", "Diksha"].includes(contentProviderType)) {
        return (
            <div className="pdf-canvas-containerBound-video">
                <PlayerComponent
                    videoId={clickedContent?.fileInfo?.videoID ? helper(clickedContent?.fileInfo?.videoID) :
                        null}
                    handleUserLastSeen={handleUserLastSeen}
                    ref={playerRef}
                    setType={setType}
                    setBookmarks={setBookmarks}
                    handleBookmarkClick={handleBookmarkClick}
                    handleTimeUpdate={handleTimeUpdate}
                    key={clickedContent?.fileInfo?._id}
                />
            </div>
            // <div>
            //     <Player
            //         className="videoPlayer"
            //         ref={playerRef}
            //         src="6b59bda773e4472798b8016c06761259"
            //         paused={true}
            //     >
            //         <ControlBar>
            //             <img
            //                 src={"/ContentM_images/FlagIcon.svg"}
            //                 className="ml-3"
            //                 alt="flagIcon"
            //                 onClick={() => {
            //                     // handleBookmarkClick();
            //                     setType("video");
            //                 }}
            //             ></img>
            //         </ControlBar>
            //         <video onTimeUpdate={handleTimeUpdateVdoCiphyer} />
            //     </Player>
            // </div>
        );
    } else if (["Youtube", "Weblink"].includes(contentProviderType)) {
        return (
            <div className="pdf-canvas-containerBound-video">
                <PlayerComponent
                    handleUserLastSeen={handleUserLastSeen}
                    ref={playerRef}
                    setType={setType}
                    setBookmarks={setBookmarks}
                    handleBookmarkClick={handleBookmarkClick}
                    handleTimeUpdate={handleTimeUpdate}
                    key={clickedContent?.fileInfo?._id}
                    clickedContent={clickedContent}
                    contentProviderType={contentProviderType}
                />
            </div>
        );
    } else {
        <p>Unsupported Media Type</p>;
    }

    return (
        <div>

        </div>
    )
}

export default MediaRenderer